import React, { FunctionComponent, useContext, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getWorldTitle, ModeRouteParams } from '../mode/Mode';
import logos from '../../media/logos-flag.png';
import Character from '../../components/character/Character';
import multipleOptionBack from '../../media/multiple-option-back.png';
import characterCap from '../../media/character-cap.png';
import introCounterBackground from '../../media/intro-counter-background.png';
import scoreReviewBoard from '../../media/score-review-board.png';
import scoreHeroBadge from '../../media/score-hero-badge.png';
import GameContext from '../../context/GameContext';
import questionnaires from '../questionnaire/questionnaires';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, firestore } from '../../../services/firebase';
import { GroupGame } from '../group/Group';
import Information from '../../components/common/Information';

interface ScoreProps {}

const Score: FunctionComponent<ScoreProps> = () => {
    const history = useHistory();
    const routerParams = useParams<ModeRouteParams>();
    const { singlePlayerGameState, handleMainSound } = useContext(GameContext);

    const handleGoToLobby = () => {
        history.push(`${process.env.PUBLIC_URL}/lobby`);
    };

    const handleGoToReview = () => {
        history.push(`${process.env.PUBLIC_URL}/review/${routerParams.worldId}`);
    };

    const finishGameForPlayer = async () => {
        const gameRef = doc(firestore, 'games', routerParams.groupId);
        const gameSnap = await getDoc(gameRef);
        const existingGroup = gameSnap.data() as GroupGame;

        let updatedGame = { ...existingGroup };

        const playerIndex = updatedGame.players.findIndex((player) => player.uid === auth.currentUser?.uid);

        if (playerIndex >= 0) {
            updatedGame.players[playerIndex].isPlaying = false;
        }

        await setDoc(gameRef, { ...updatedGame });
    };

    useEffect(() => {
        handleMainSound('play-victory-effect');

        if (routerParams.groupId) finishGameForPlayer();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="page-container page-score animate__animated animate__fadeIn">
                <>
                    <div className="outer">
                        <div className="box"></div>
                    </div>
                    <div className="outer outer2">
                        <div className="box box2"></div>
                    </div>
                </>
                <img
                    src={getWorldTitle(routerParams)}
                    className="world-logo animate__animated animate__backInLeft"
                    alt="¡Bienvenido/a a la Cuenca!"
                />
                <img
                    src={logos}
                    className="common-logos animate__animated animate__slideInDown"
                    alt="Héroes de la Cuenca"
                />
                <div className="game-menu">
                    <div className="character-mini-container animate__animated animate__bounceIn">
                        <img
                            src={characterCap}
                            className="character-cap animate__animated animate__pulse animate__infinite"
                            alt="héroe de la cuenca"
                        />
                        <Character />
                        <div className="intro-counter-background-container" style={{ zIndex: -1 }}>
                            <img
                                src={introCounterBackground}
                                alt="¡Empezamos!"
                                className="intro-counter-background score-winner-background"
                            />
                        </div>
                    </div>
                    <img
                        src={multipleOptionBack}
                        className="game-menu-button-back animate__animated animate__backInUp"
                        alt="Regresar"
                        onClick={handleGoToLobby}
                    />
                </div>
                <div className="score-result">
                    <h1>{singlePlayerGameState.score > 0 ? '¡Felicidades!' : 'Vaya...'}</h1>
                    <p>
                        {singlePlayerGameState.score > 0
                            ? `Has respondido correctamente ${singlePlayerGameState.score} de ${
                                  questionnaires[routerParams.worldId].length
                              } preguntas.`
                            : '¡No te desanimes! revisa a continuación las respuestas para aprender más sobre la Cuenca!'}
                    </p>
                </div>
                <img
                    src={scoreHeroBadge}
                    alt="¡Felicidades, Héroe de la Cuenca!"
                    className="score-hero-badge animate__animated animate__pulse animate__infinite"
                />
                <img
                    src={scoreReviewBoard}
                    alt="Revisar respuestas"
                    className="score-review-board animate__animated animate__zoomInUp"
                    onClick={handleGoToReview}
                />
                <div className="share-facebook">
                    <iframe
                        title="Compartir en facebook"
                        src="https://www.facebook.com/plugins/share_button.php?href=https://ucp.edu.co/heroes-de-la-cuenca/&layout=button&size=large&appId=165982675245655&width=103&height=28"
                        width="103"
                        height="28"
                        style={{ border: 'none', overflow: 'hidden' }}
                        scrolling="no"
                        frameBorder="0"
                        allowFullScreen={true}
                        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    ></iframe>
                </div>
            </div>
            <Information helpText='Ahora que has terminado la partida, puedes compartir tu logro e insignia de Héroes de la Cuenca haciendo clic en el botón "compartir" de Facebook. También puedes hacer un recorrido del cuestionario resuelto para aprender más sobre la Cuenca haciendo clic sobre el tablero central.' />
        </>
    );
};

export default Score;
